import React, { FC } from 'react';
import { GrowBolt } from '@menuzen/icon/build/outline';

export interface ButtonUpgradeProps {
    btnText?: string;
    btnClass?: string;
    onClick: () => void;
}
const PlanUpgradeButton: FC<ButtonUpgradeProps> = ({ onClick, btnText = 'Upgrade', btnClass = '' }) => {
    return (
        <>
            <div
                className={`flex items-center text-12 leading-16 cursor-pointer text-white  px-14 py-7 rounded-round bg-gradient-upgrade-90 ${btnClass}`}
                onClick={onClick}
            >
                <div className={`w-20 h-20 text-20 flex items-center justify-center `}>
                    <GrowBolt />
                </div>
                <span>{btnText}</span>
            </div>
        </>
    );
};

export default PlanUpgradeButton;
